import { render, staticRenderFns } from "./myAudio.vue?vue&type=template&id=27994ceb&scoped=true&"
import script from "./myAudio.vue?vue&type=script&lang=js&"
export * from "./myAudio.vue?vue&type=script&lang=js&"
import style0 from "./myAudio.vue?vue&type=style&index=0&id=27994ceb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27994ceb",
  null
  
)

export default component.exports